import React from 'react';
import PropTypes from 'prop-types';

import { DemoPage } from '../../partials';

// Import code snippets as text.
const html = require('!raw-loader!flexbox-patterns/src/examples/centered-prompt.html');
const css = require('!raw-loader!flexbox-patterns/src/styles/centered-prompt.css');

export const CenteredPromptDemo = ({ name }) => (
  <DemoPage title={name} html={html} css={css}>
    <p>
      Centering content without flexbox usually involves some hacks, like using
      absolute positioning and then offsetting the centered content with a 2D
      transform. With flexbox you just need to set 4 properties on the container
      element:
    </p>

    <ul>
      <li>
        <code>display: flex</code> which by now we know and love.
      </li>

      <li>
        <code>flex-direction: column</code> rotates the main axis so that
        content is laid out vertically instead of horizontally.
      </li>

      <li>
        <code>justify-content: center</code> groups the children as close as
        possible to one another, in the center of their container.
      </li>

      <li>
        <code>align-items: center</code> centers the children along this axis,
        having a similar effect as setting
        <code>text-align: center</code>.
      </li>
    </ul>
  </DemoPage>
);

CenteredPromptDemo.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/demos/CenteredPromptDemo.js